import axios, { AxiosInstance } from 'axios';

let flippingInstance: AxiosInstance;

export const getFlippingInstance = (): AxiosInstance => {
  if (!flippingInstance) {
    flippingInstance = axios.create({
      baseURL: import.meta.env.VITE_FLIPPING_URL,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `admin-api-key ${import.meta.env.VITE_FLIPPING_API_KEY}`,
        Accept: 'application/json',
      },
    });
  }
  return flippingInstance;
};
